// Password updates contact the broker's proxy on every request. Never retry
// automatically, and let the form handle errors without logging request data.
const requestOptions = { timeRetry: false, noInterceptorError: true }

export default {
  namespaced: true,
  actions: {
    updateTradevanEccsPwd ({ rootState }, password) {
      return rootState.axios.post('/cc/v1frontend/labelcc/update-tradevan-eccs-pwd', {
        userPwd: password,
      }, requestOptions)
    },
    updateNatswPortalPwd ({ rootState }, password) {
      return rootState.axios.post('/cc/v1frontend/labelcc/update-natsw-portal-pwd', {
        password,
      }, requestOptions)
    },
    updateTradevanTdisPwd ({ rootState }, password) {
      return rootState.axios.post('/cc/v1frontend/labelcc/update-tradevan-tdis-pwd', {
        userPassword: password,
      }, requestOptions)
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/cc/labelcc.js